import TagLowBattery from "./TagLowBattery.js";
import TagUnactivated from "./TagUnactivated.js";
import TagPairingValidationAction from "./TagPairingValidationAction.js";
import TagPairingSelectionRenderer from "./TagPairingSelectionRenderer.js";
function install(molten) {
  // Register validation views
  molten.addPlugin('WizardStep', {
    type: 'recovr.TagLowBattery',
    content: TagLowBattery
  });
  molten.addPlugin('WizardStep', {
    type: 'recovr.TagUnactivated',
    content: TagUnactivated
  });
  // Register the pairing validation action
  molten.addPlugin('WizardAction', TagPairingValidationAction);
  molten.addPlugin('PairingSelectionRenderer', TagPairingSelectionRenderer);
}
export default {
  install
};